import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { IconNames } from '../../../../common/constants/icon-names';
import { SvgIconComponent } from '../../../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-select-profile',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    TranslateModule,
    SvgIconComponent,
  ],
  templateUrl: './monitoring-select-profile.component.html',
  styleUrls: ['./monitoring-select-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonitoringSelectProfileComponent {
  @Input() name: string;
  @Input() id: number;
  @Input() isUpdateProfileAvailable: boolean;
  @Input() isLabelVisible = true;
  @Input() isUpdateProfileVisible = true;
  @Input() defaultProfileControl?: FormControl<boolean>;
  @Output() removeProfile = new EventEmitter<void>();
  @Output() selectProfile = new EventEmitter<void>();
  @Output() updateProfile = new EventEmitter<void>();

  iconNameList = IconNames;
}
